import React from "react";
import { IconButton, Tooltip } from "@toddle-edu/ds-web";
import { AssessmentAddOutlined, NoteOutlined } from "@toddle-edu/ds-icons";

import classes from "./InstructionAndToolsController.scss";

const InstructionAndToolsController = ({
  t,
  hasInstruction,
  hasAssessmentTools,
  worksheetBasicDetailInfo,
  setWorksheetBasicDetailsInfo,
}) => {
  const { showInstructions, showAssessmentTools } = worksheetBasicDetailInfo;

  if (showInstructions && showAssessmentTools) return null;
  if (hasAssessmentTools && hasInstruction) return null;

  return (
    <div className={classes.instructionAndToolsController}>
      {!showInstructions && !hasInstruction && (
        <Tooltip
          tooltip={t("worksheet:worksheet_instructions")}
          placement={"top"}
          showArrow={true}
        >
          <IconButton
            variant={"outlined-subtle"}
            size="large"
            icon={<NoteOutlined />}
            testId="worksheet-basic-details-instruction-icon"
            onClick={() =>
              setWorksheetBasicDetailsInfo({
                ...worksheetBasicDetailInfo,
                showInstructions: true,
              })
            }
          />
        </Tooltip>
      )}
      {!showAssessmentTools && !hasAssessmentTools && (
        <Tooltip
          tooltip={t("classRoom:assessment_tools")}
          placement={"top"}
          showArrow={true}
        >
          <IconButton
            variant={"outlined-subtle"}
            size="large"
            icon={<AssessmentAddOutlined />}
            testId="worksheet-basic-details-assessment-tools-icon"
            onClick={() =>
              setWorksheetBasicDetailsInfo({
                ...worksheetBasicDetailInfo,
                showAssessmentTools: true,
              })
            }
          />
        </Tooltip>
      )}
    </div>
  );
};

export default InstructionAndToolsController;
